var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('es-card-wrap1',{attrs:{"custom-style":(_vm.customStyle)}},[((_vm.title))?_c('es-descriptions',{attrs:{"title":(_vm.title),"custom-style":({padding: '12px 12px 16px'})}},[_vm._t("default")],2):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }